import { useState } from 'react'
import styled from 'styled-components'
import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from "react-i18next"

const StyledSearch = styled(Autocomplete)`
  border: 0;
  min-width: 550px;
  width: 100%;
  outline: none;
`

const AutoCompleteSearch = ({ options, onSelect }) => {
  const [value, setValue] = useState(null)
  const [inputValue, setInputValue] = useState('')
  const { t } = useTranslation('common')

  return (
    <StyledSearch
      id='user-search-list'
      value={value}
      onChange={(_, newValue) => {
        onSelect({ id: newValue.id, name: newValue.name })
        setValue(newValue)
      }}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => {
        setInputValue(newInputValue)
      }}
      getOptionLabel={option => option.name}
      options={options}
      renderInput={params => (
        <>
          <TextField
            placeholder={t('admin_actions_modal.user_placeholder')}
            {...params}
          />
        </>
      )}
    />
  )
}

export default AutoCompleteSearch
